import type { SanityPageBuilderScrollFeaturesFeature, SanityPageBuilderScrollFeaturesSection, SanityPageBuilderSection } from "@ouster/shared";
import { ScrollFeaturesBlockView, type ScrollFeaturesBlockViewItem } from "~/features/blocks/inventory/scroll-features";
import { SanityMediaFigure, hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderScrollFeaturesSection;
  };
};
type ScrollFeaturesViewItem = ScrollFeaturesBlockViewItem & Pick<SanityPageBuilderScrollFeaturesFeature, "_key">;
export function SanityScrollFeaturesSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const features = sectionContent.features?.map<ScrollFeaturesViewItem>((feature, index) => {
    const hasMedia = hasRenderableSanityMedia(feature.media);
    return {
      _key: feature._key,
      key: feature._key || index,
      media: hasMedia ? <SanityMediaFigure fit="cover" media={feature.media} /> : undefined,
      hasMedia,
      hasOverlay: Boolean(feature.headline),
      headline: feature.headline
    };
  }) ?? [];
  return <ScrollFeaturesBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} features={features} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}